module.exports = __webpack_public_path__ + "media/marker_orange.8db57091.svg";